import React, { ReactNode } from 'react';
import classnames from 'classnames';
import { Chip, ChipTypes } from '../chips';
import { Avatar } from '../thumbnails';
import { getInitials } from '../../utils/getInitials';

import styles from './user-list-item.css';
import ListItem from './list-item';

interface Props {
  /** Name of the user */
  name: string;
  /** Email of the user */
  email: string;
  /** URL of the image to display inside the avatar */
  image?: string;
  /** An array of chips to display the user type. Please refer to Chips for more information. */
  types?: ChipTypes[];
  /** Adds additional classes to the component. */
  className?: string;
  /** Contents of the flyout menu */
  flyoutMenu?: ReactNode;
  /** Provides a data-testid */
  'data-testid'?: string;
}

const UserListItem = (props: Props) => {
  const { name, email, image, types, className, flyoutMenu, ...rest } = props;

  const itemClasses = classnames(className, styles.item);

  return (
    <ListItem className={itemClasses} flyoutAlignX="left" flyoutMenu={flyoutMenu} {...rest}>
      <Avatar
        initials={getInitials(name)}
        {...(image && { image })}
        className={styles.avatar}
        data-testid="user-list-avatar"
      />
      <div className={styles.main}>
        <div className={styles.user}>
          <div className={styles.name} data-testid="user-name">
            {name}
          </div>
          <div className={styles.email} data-testid="user-email">
            {email}
          </div>
        </div>
        {types &&
          types.length > 0 &&
          types.map((t: ChipTypes) => (
            <Chip type={t} className={styles.typeChip} data-testid="user-chip" key={t} />
          ))}
      </div>
    </ListItem>
  );
};

export default UserListItem;
